import React from "react";
import Slider from "react-slick";

import brandLogo1 from "../../../assets/img/partner1.jpg";
import brandLogo2 from "../../../assets/img/partner2.jpg";
import brandLogo3 from "../../../assets/img/partner3.jpg";
import brandLogo6 from "../../../assets/img/brand/6.png";
import brandLogo7 from "../../../assets/img/partner7.png";
import brandLogo8 from "../../../assets/img/partner8.webp";
import brandLogo9 from "../../../assets/img/partner9.png";
import brandLogo10 from "../../../assets/img/partner10.png";
import brandLogo11 from "../../../assets/img/partner11.png";
import brandLogo12 from "../../../assets/img/partner12.png";
import brandLogo13 from "../../../assets/img/partner13.png";
import brandLogo14 from "../../../assets/img/partner14.png";
import brandLogo15 from "../../../assets/img/partner15.png";
import brandLogo16 from "../../../assets/img/partner16.png";

const BrandThree = (props) => {
  const { brandBg, brandClass } = props;

  const brandBgStyle = {
    backgroundImage: `url(${brandBg ? brandBg : ""})`,
  };

  const brandBgDefaultStyle = {
    backgroundColor: "transparent",
  };

  const sliderSettings = {
    dots: false,
    centerMode: false,
    infinite: true,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div
      className={brandClass ? brandClass : "rs-partner style2"}
      style={brandBg ? brandBgStyle : brandBgDefaultStyle}
    >
      <div className="container hide-x-scrollbar d-flex gap-5 d-flex flex-nowrap overflow-x-auto">
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo1} alt="" />
            </a>
          </div>
        </div>
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo2} alt="" />
            </a>
          </div>
        </div>

        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo7} alt="" />
            </a>
          </div>
        </div>
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo8} alt="" />
            </a>
          </div>
        </div>
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo3} alt="" />
            </a>
          </div>
        </div>
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo6} alt="" />
            </a>
          </div>
        </div>
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo8} alt="" />
            </a>
          </div>
        </div>
        <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo9} alt="" />
            </a>
          </div>
        </div>
            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo10} alt="" />
            </a>
          </div>
        </div>

            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo11} alt="" />
            </a>
          </div>
        </div>

            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo12} alt="" />
            </a>
          </div>
        </div>

            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo13} alt="" />
            </a>
          </div>
        </div>

            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo14} alt="" />
            </a>
          </div>
        </div>

            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo15} alt="" />
            </a>
          </div>
        </div>

            <div className="partner-item">
          <div className="logo-img">
            <a href="#">
              <img src={brandLogo16} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandThree;
